<template>
    <CModal
        title="Возврат средств"
        :show.sync="modal.visible"
        :footer="false">
        <template>
            <div slot="body-wrapper" class="modal-body">
                <CForm>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Сумма возврата</CCol>
                        <CInput v-model="refund" placeholder="Сумма возврата" />
                    </CRow>
                </CForm>
            </div>
            <div slot="footer">
                <CButton
                    color="primary"
                    class="mr-3"
                    @click="$emit('refund', refund)">Отправить</CButton>
                <CButton color="light" @click="$emit('cancel')">Отмена</CButton>
            </div>
        </template>
    </CModal>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';

    export default {
        name: 'OrderRefund',

        props: {
            refund: {
                type: [String, Number],
                default: '0'
            },
            modal: {
                type: Object,
                default: () => {},
            },
        },

        data() {
            return {
                isAuthorized: false,
            
            };
        },

        async mounted() {
        },

        methods: {},
    };
</script>

<style scoped>
</style>
